import {
  fetchV1Ledgers,
  fetchV1AccountLedgers,
} from "@/services/v1/accountAPIService";

export default {
  state: {
    ledgers: [],
    ledgerPageSize: 5,
    totalLedgerCount: 0,
  },
  getters: {
    ledgers: (state) => state.ledgers,
    currentLedgerPageSize: (state) => state.ledgerPageSize,
    totalLedgerCount: (state) => state.totalLedgerCount,
  },
  mutations: {
    SET_LEDGERS(state, ledgers) {
      state.ledgers = ledgers;
    },
    SET_LEDGER_PAGE_SIZE(state, pageSize) {
      state.ledgerPageSize = pageSize;
    },
    SET_TOTAL_LEDGER_COUNT(state, count) {
      state.totalLedgerCount = count;
    },
  },
  actions: {
    async fetchLedgers(
      { commit },
      { account_type = "", account_sub_type = "", page = 1, pageSize = 5 } = {}
    ) {
      //   commit("SET_LOADING", true);
      try {
        const response = await fetchV1Ledgers(
          page,
          pageSize,
          account_type,
          account_sub_type
        );
        commit("SET_LEDGERS", response.results);
        commit("SET_LEDGER_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_LEDGER_COUNT", response.count);
      } catch (error) {
        console.error("Error fetching ledgers:", error);
      } finally {
        // commit("SET_LOADING", false);
        console.log("finally...");
      }
    },
    async fetchAccountLedgers(
      { commit },
      { accountCode = null, page = 1, pageSize = 5 } = {}
    ) {
      //   commit("SET_LOADING", true);
      try {
        const response = await fetchV1AccountLedgers(
          page,
          pageSize,
          accountCode
        );
        commit("SET_LEDGERS", response.results);
        commit("SET_LEDGER_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_LEDGER_COUNT", response.count);
      } catch (error) {
        console.error("Error fetching account ledgers:", error);
      } finally {
        // commit("SET_LOADING", false);
        console.log("finally...");
      }
    },
  },
};
